import React from "react";
import PropTypes from "prop-types";
import {
  SubtitleItem,
  SubtitleIcon,
  SubtitleItemCaption,
  Pronunciation,
  Title,
} from "./_.styled";

const ContentHeaderSubtitleItem = ({
  heading,
  title,
  pronunciation,
  content,
  testId,
  icon,
  pageType,
}) => (
  <SubtitleItem data-testid={testId} pageType={pageType} heading={heading}>
    {title && (
      <Title
        data-testid="content-header-dialog-subtitle"
        element="h6"
        color="primary"
        fontFamily="secondary"
        fontWeight="normal"
      >
        {title}
      </Title>
    )}

    {icon && (
      <SubtitleIcon
        data-testid={icon.testId}
        icon={{ glyph: icon.glyph, color: icon.color, size: icon.size }}
      />
    )}
    {heading && (
      <SubtitleItemCaption>
        {heading}
        {pronunciation && (
          <>
            (
            <Pronunciation
              dangerouslySetInnerHTML={{ __html: pronunciation }}
            />
            )
          </>
        )}
        {content && <>:&nbsp;</>}
      </SubtitleItemCaption>
    )}
    {content && (
      <span dangerouslySetInnerHTML={{ __html: content.join(", ") }} />
    )}
  </SubtitleItem>
);

ContentHeaderSubtitleItem.propTypes = {
  heading: PropTypes.string,
  title: PropTypes.string,
  pronunciation: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.string.isRequired),
  testId: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    glyph: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
  }),
};

ContentHeaderSubtitleItem.displayName = "ContentHeaderSubtitleItem";

export default ContentHeaderSubtitleItem;
